// sagas/closureSaga.js
import { takeLatest, call, put } from "redux-saga/effects";
import { fetchNudgesNew } from "../../../services/accIqService";
import {
  SUBMIT_NUDGES_NEW_REQUEST,
  submitNudgesNewSuccess,
  submitNudgesNewFailure
} from "../actions/NudgesNewActions";
// import { fetchClosureAgent } from "../../../services/accIqService";

// Saga function
function* handleNudgesNewSubmission(action) {
  try {
    const response = yield call(
      fetchNudgesNew, 
      action.payload.clientName, 
      action.payload.accountName, 
  );
    // console.log("NudgesLatest: "+JSON.stringify(response))
    yield put(submitNudgesNewSuccess(response || "No nudges found."));
  } catch (error) {
    yield put(submitNudgesNewFailure(error.error));
  }
}

export function* watchNudgesNewSubmission() {
  yield takeLatest(SUBMIT_NUDGES_NEW_REQUEST, handleNudgesNewSubmission);
}